import React from 'react';
import { connect } from 'react-redux';
import { CallbackComponent } from 'redux-oidc';
import { Redirect } from 'react-router-dom';
import { UserManager } from 'oidc-client'

import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner';
import userManager from '../../userManager';

interface IState {
    userManager?: UserManager;
    userManagerTask: Promise<UserManager>;
    redirectUrl?: string;
}

class CallbackIndex extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props);

        this.state = {
            userManagerTask: userManager
        };
    }

    public componentDidMount() {
        userManager.then(mngr => this.setState({ userManager: mngr }));
    }

    public render() {
        if (this.state.redirectUrl) {
            return <Redirect to={this.state.redirectUrl}/>; 
        }

        if (this.state.userManager) {
            return <CallbackComponent userManager={this.state.userManager} successCallback={this.onSuccessCallback(this)} errorCallback={this.onErrorCallback}>
                <section className="section">
                    <div className="deck">
                        <div className="w--md">
                            <Spinner size={SpinnerSize.Large} />
                        </div>
                    </div>
                </section>
            </CallbackComponent>;
        }

        return <Spinner size={SpinnerSize.Large}/>;
    }

    private onSuccessCallback(ctx: CallbackIndex) {
        return async (user: any) => {
            let redirectUrl = '/';

            if (user && user.state && user.state.redirectUrl) {
                redirectUrl = user.state.redirectUrl;
            }

            this.setState({ redirectUrl });
        }
    }

    private onErrorCallback(e: any): void {
        throw e;
    }
}

const container = connect()(CallbackIndex);

export default container;